import DOMPurify from 'dompurify';

const allowedTags = [
    'e2-input-field',
    'e2-link-popup',
    'e2-input-error',
    'e2-dialog',
    'e2-beauty-card-popup-content',
    'e2-tooltip',
    'e2-hidden-input-field',
    'e2-radio-group-field',
    'e2-select-field',
    'e2-native-select',
    'e2-when-equal',
    'e2-address-suggestions-list',
    'v-root',
    'e2-impression-tracker',
    'e2-render-template-when',
];

const allowedAttributes = [
    'v-slot',
    'slot',
    'target',
    'addclass',
    'close-bg-click',
    'btn-close',
    'close-button-class',
    'no-scroll',
    'text',
    'image-url',
    'image-alt',
    'show-on-hover',
    'toggle-state',
    'disabled',
    'name',
    'placeholder',
    'class-modifier',
    'default-value',
    'labelled',
    'filled',
    'disable-one-element',
    'display-mode',
    'class-modifier',
    'default-value',
    'labelled',
    'filled',
    'disable-one-element',
    'display-mode',
    'displaymode',
    'css-class',
    'equal-to',
    'highlight',
    'storeName',
    'nested-form-redux-path',
    'tracker-type',
    'track-intersection',
    'track-click',
    'intersection-threshold',
    'event-label',
    'not',
];
export const aggressiveSanitize = string =>
    DOMPurify.sanitize(string, {
        ADD_TAGS: [],
        ADD_ATTR: [],
    });

export default (target, allowStyles) =>
    DOMPurify.sanitize(target, {
        ADD_TAGS: allowedTags,
        ADD_ATTR: allowedAttributes,
        ...(allowStyles ? { FORCE_BODY: true } : {}),
    });
